import { useEffect } from 'react';

export const useAuthTheme = () => {
  useEffect(() => {
    document.body.classList.add('auth-page');
    return () => {
      document.body.classList.remove('auth-page');
    };
  }, []);
}; 